// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-entity-fk-relations directly.

/**
 * docEntityTypesInHashTables is a mapping of doc entity types to a boolean indicating
 * whether the entity type can appear as a key in any doc-level hash table (fkHashTable()
 * or fkHashJoinTable() fields). This includes both self-referential hash tables (locked, hidden)
 * and join tables (entityGroups, entityRoomLayouts, componentMembers).
 */
export const docEntityTypesInHashTables = {
  ANNOTATION: true,
  BLOCK: true,
  CASEWORK: true,
  CEILING: true,
  CIP_COMPONENT: true,
  COLUMN: true,
  COMPONENT_INSTANCE: true,
  CONTENT_TEMPLATE: true,
  CONTENT_TEMPLATE_INSTANCE: true,
  DATA_SEQUENCE: true,
  DATUM: true,
  ELECTRICAL_DEVICE: true,
  ELECTRICAL_LAYOUT: true,
  FACADE: true,
  FLOOR: true,
  FLOOR_FINISH: true,
  FLOOR_SYSTEM: true,
  FOUNDATION: true,
  FOUNDATION_ASSEMBLY: true,
  FOUNDATION_COMPONENT: true,
  FOUNDATION_SYSTEM: true,
  FRAME_FLOOR_ASSEMBLY: true,
  FRAMING_COMPONENT: true,
  FREEFORM_WALL: true,
  GLOBAL_PARAMETER: true,
  GROUP: true,
  HEADER_ASSEMBLY: true,
  LEVEL: true,
  MASONRY_COMPONENT: true,
  MEASUREMENT: true,
  MODIFIER: true,
  OPENING: true,
  PALETTE: true,
  PROFILE: true,
  PROP: true,
  PROP_INSTANCE: true,
  RAILING: true,
  REFERENCE_GEOM: true,
  ROOF: true,
  ROOF_SYSTEM: true,
  ROOF_VOLUME: true,
  ROOM: true,
  SETTINGS_SET: true,
  SHEATHING_COMPONENT: true,
  SHEET: true,
  SITE: true,
  SLAB_COMPONENT: true,
  SLAB_FLOOR_ASSEMBLY: true,
  STAIR_BLOCK: true,
  STAIR_SYSTEM: true,
  SYSTEM_PARAMETER: true,
  UNDERLAY: true,
  WALL_PLANE_ASSEMBLY: true,
} as const;

/**
 * docHashTableFieldToValueEntityTypes maps Doc self-referential hash table field names
 * (DocForeignHashTable / fkHashTable — locked, hidden) to the entity types that the
 * hash table values represent. Values are entity handles of the same entity as the key.
 */
export const docHashTableFieldToValueEntityTypes = {
  hidden: [
    "GROUP",
    "LEVEL",
    "BLOCK",
    "ROOM",
    "STAIR_SYSTEM",
    "STAIR_BLOCK",
    "ROOF_SYSTEM",
    "ROOF",
    "FOUNDATION_SYSTEM",
    "FOUNDATION",
    "UNDERLAY",
    "REFERENCE_GEOM",
    "FLOOR",
    "MEASUREMENT",
    "FLOOR_SYSTEM",
  ],
  locked: [
    "GROUP",
    "LEVEL",
    "BLOCK",
    "ROOM",
    "STAIR_SYSTEM",
    "STAIR_BLOCK",
    "RAILING",
    "ROOF_SYSTEM",
    "FOUNDATION_SYSTEM",
    "UNDERLAY",
    "REFERENCE_GEOM",
    "MEASUREMENT",
    "FLOOR_SYSTEM",
  ],
} as const;

/**
 * docHashTableFieldToHashEntityTypes maps Doc self-referential hash table field names
 * (DocForeignHashTable / fkHashTable — locked, hidden) to the entity types that can appear
 * as keys (hashed entity handles).
 */
export const docHashTableFieldToHashEntityTypes = {
  hidden: [
    "ROOM",
    "LEVEL",
    "UNDERLAY",
    "BLOCK",
    "STAIR_BLOCK",
    "GROUP",
    "STAIR_SYSTEM",
    "REFERENCE_GEOM",
    "MEASUREMENT",
    "FLOOR_SYSTEM",
    "ROOF_SYSTEM",
    "FOUNDATION_SYSTEM",
    "ROOF",
    "FOUNDATION",
    "FLOOR",
  ],
  locked: [
    "RAILING",
    "ROOM",
    "LEVEL",
    "UNDERLAY",
    "BLOCK",
    "STAIR_BLOCK",
    "GROUP",
    "STAIR_SYSTEM",
    "REFERENCE_GEOM",
    "MEASUREMENT",
    "FLOOR_SYSTEM",
    "ROOF_SYSTEM",
    "FOUNDATION_SYSTEM",
  ],
} as const;

/**
 * docHashJoinTableFieldToValueEntityType maps Doc hash join table field names
 * (DocForeignHashJoinTable / fkHashJoinTable — entityGroups, entityRoomLayouts,
 * componentMembers) to the entity types that the values reference as FK IDs.
 *
 * For example:
 * - entityGroups maps to ["GROUP"] (values are Group IDs)
 * - entityRoomLayouts maps to ["ROOM_LAYOUT"] (values are RoomLayout IDs)
 * - componentMembers maps to ["COMPONENT"] (values are Component IDs)
 */
export const docHashJoinTableFieldToValueEntityType = {
  componentMembers: "COMPONENT",
  entityGroups: "GROUP",
  entityRoomLayouts: "ROOM_LAYOUT",
} as const;

/**
 * docHashJoinTableFieldToHashEntityTypes maps Doc hash join table field names
 * (DocForeignHashJoinTable / fkHashJoinTable — entityGroups, entityRoomLayouts,
 * componentMembers) to the entity types that can appear as keys (hashed entity handles).
 *
 * For example:
 * - entityGroups maps to groupable entity types (the entities that can be assigned to a group)
 * - componentMembers maps to component member entity types
 */
export const docHashJoinTableFieldToHashEntityTypes = {
  componentMembers: [
    "RAILING",
    "ROOM",
    "LEVEL",
    "BLOCK",
    "COMPONENT_INSTANCE",
    "STAIR_SYSTEM",
    "FLOOR_SYSTEM",
    "ROOF_SYSTEM",
    "FOUNDATION_SYSTEM",
    "ROOF",
  ],
  entityGroups: [
    "DATUM",
    "ANNOTATION",
    "CONTENT_TEMPLATE",
    "RAILING",
    "CONTENT_TEMPLATE_INSTANCE",
    "PROP",
    "SHEET",
    "SETTINGS_SET",
    "BLOCK",
    "PROFILE",
    "CASEWORK",
    "CEILING",
    "CIP_COMPONENT",
    "FOUNDATION_COMPONENT",
    "COLUMN",
    "FOUNDATION_ASSEMBLY",
    "FRAMING_COMPONENT",
    "MASONRY_COMPONENT",
    "SLAB_COMPONENT",
    "GLOBAL_PARAMETER",
    "SYSTEM_PARAMETER",
    "DATA_SEQUENCE",
    "SITE",
    "STAIR_BLOCK",
    "STAIR_SYSTEM",
    "REFERENCE_GEOM",
    "MEASUREMENT",
    "ROOF_SYSTEM",
    "FREEFORM_WALL",
    "ROOF",
    "WALL_PLANE_ASSEMBLY",
    "PALETTE",
    "PROP_INSTANCE",
    "OPENING",
    "FLOOR",
    "FLOOR_FINISH",
    "FACADE",
    "ELECTRICAL_DEVICE",
    "ELECTRICAL_LAYOUT",
    "MODIFIER",
    "ROOF_VOLUME",
    "HEADER_ASSEMBLY",
    "FRAME_FLOOR_ASSEMBLY",
    "SLAB_FLOOR_ASSEMBLY",
    "SHEATHING_COMPONENT",
  ],
  entityRoomLayouts: ["ANNOTATION", "CONTENT_TEMPLATE_INSTANCE", "CASEWORK", "PROP_INSTANCE", "OPENING"],
} as const;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-entity-fk-relations directly.
